const STORAGE_KEY = 'StREAM_LOCALE'

export class LocalizationUtils {
  setPreferredLanguage (locale) {
    localStorage.setItem(STORAGE_KEY, locale)
  }

  getPreferredLanguage (localeList) {
    const locale = localStorage.getItem(STORAGE_KEY)
    if (this.validateLocale(localeList, locale)) {
      return locale
    }
    this.clearPreference()
    return this.getDefaultLanguage(localeList)
  }

  clearPreference () {
    localStorage.removeItem(STORAGE_KEY)
  }

  getDefaultLanguage (localeList) {
    return localeList[1].name
  }

  getFallbackLanguage (localeList) {
    return localeList[0].name
  }

  validateLocale (localeList, locale) {
    return localeList.find(x => x.name === locale)
  }
}



// WEBPACK FOOTER //
// ./src/utils/localization-utils.js